import React, {Component} from "react";
import { inject, observer } from "mobx-react";
import DataWrapper from '../../principal/containers/DataWrapper';
import {TabelaAdministracao} from "../../comum/components/TabelaAdministracao";
import TimesheetsNaoGeradosStore from "../stores/TimesheetsNaoGeradosStore";
import {
    formatarDataMesAno, formatarNomeProduto,
    motivoContratacaoFormatter, mudarDiasAlerta, nullable, ordenarData, ordenarSLA,
    slaFormatter
} from "../../../utils/formatar";
import ParametrosGeraisStore from "../../administracao/stores/ParametrosGeraisStore";
import {formatarDataISO8601} from "../../../utils/formatar";
import {sortAlphaNum} from "../../../utils/ordenar";
import { getStatusTimesheetById } from "../../../utils/enums";
import {toast} from "react-toastify";

//RHFPP-1447-automatizacao-timesheets

@inject("store")
@DataWrapper
@observer
export class TimesheetsNaoGerados extends Component {
    constructor(props) {
        super(props);
        this.appStore                   = this.props.store.appStore;
        this.tituloPaginaStore          = this.props.store.tituloPaginaStore;
        this.modalStore                 = this.props.store.modalStore;
        this.controller                 = new TimesheetsNaoGeradosStore();
        this.parametrosGeraisStore = new ParametrosGeraisStore();
    }

    componentWillMount() {
        //TODO: usar component Modal
        this.modalStore.setSubmitted(false);
        this.modalStore.setSubmitMensagemErro("");
        this.modalStore.setLoading(false);

    }

    componentDidMount() {
        this.tituloPaginaStore.setTitulo("Timesheets não gerados");

        // recupera os parametros para verificar se o iniciar fluxo está em execução 
        this.parametrosGeraisStore.carregarLista(); 
        this.controller.carregarLista();
        this.tituloPaginaStore.setBotoesMobile([
            {
                label: "Ordenar",
                icone: "sort",
                acao: () => this.modalStore.toggleModal('ordenar')
            }
        ]);
    }

    obterTituloMobile = (objeto) => {
        return objeto.nomeTarefa;
    };


    obterConteudoMobile = (objeto) => {
        /*
        return (
            <div>
                { "SLA: "}<div  style={{display: "inline-block"}}>{slaFormatter(objeto.sla, objeto)}</div><br/>
                { "CPF do profissional: " + nullable(objeto.cpf)}<br/>
                { "Prazo: " + nullable(formatarDataISO8601(objeto.prazo))}<br/>
                { "Solicitante: " + nullable(objeto.nomeSolicitante)}<br/>
                { "Cargo: " + nullable(objeto.cargo)}<br/>
                { "Motivo de contratação: " + nullable(motivoContratacaoFormatter(objeto.motivoContratacao))}<br/>
                { "Justificativa: " + nullable(objeto.justificativa)}<br/>
                { "Projeto/centro de resultado/finalidade: " +  nullable(formatarNomeProduto(objeto.produto))}<br/>
                { "Local trabalho MOT: " + nullable(objeto.localTrabalho)}<br/>
                { "Competência: " + nullable(formatarDataMesAno(objeto.mesCompetencia))}<br/>
                { "Data de início: " + nullable(formatarDataISO8601(objeto.dataInicio))}<br/>
                { "Data de término: " + nullable(formatarDataISO8601(objeto.dataFim))}
            </div>
        )
        */
    };

    formatarStatus = (valor) => {
        const status = getStatusTimesheetById(valor);
        return status.valor;
    };

    checkExecucaoFluxos(){
        if (this.parametrosGeraisStore.iniciarFluxosEmExecucao())
            toast.warning("Criação de fluxos em execução...");
    }

    render() {

        //TODO: inserir as outras colunas
        const colunas = [
            {
                field: "timesheetId",
                label: "Timesheet",
                funcaoOrdenacao: sortAlphaNum.bind("timesheetId")
            },{
                field: "cpf",
                label: "CPF do Profissional"
            },/*{
                field: "motNome",
                label: "Nome do profissional"
            },*/{
                field: "nomeGestorSolicitante",
                label: "Nome do Gestor"
            }/*,{
                field: "mesCompetencia",
                label: "Competência",
                dataFormat: formatarDataMesAno,
                funcaoOrdenacao: ordenarData.bind("mesCompetencia")
            }*/,{
                field: "dataInicio",
                label: "Data inicial",
                dataFormat: formatarDataISO8601,
                funcaoOrdenacao: ordenarData.bind("dataInicio")
            },{
                field: "dataFim",
                label: "Data final",
                dataFormat: formatarDataISO8601,
                funcaoOrdenacao: ordenarData.bind("dataFim")
            },/*{
                field: "contratoDataInicio",
                label: "Inicio Contrato",
                dataFormat: formatarDataISO8601,
                funcaoOrdenacao: ordenarData.bind("contratoDataInicio")
            },*/{
                field: "contratoDataTermino",
                label: "Fim Contrato",
                dataFormat: formatarDataISO8601,
                funcaoOrdenacao: ordenarData.bind("contratoDataTermino")
            },/*{
                field: "centroCustoDebito",
                label: "Centro de Custo Débito"
            },*/{
                field: "sistemaAlocacao",
                label: "Alocação"
            },{
                field: "status",
                label: "Status",
                dataFormat: this.formatarStatus
            },{
               field: "timesheetObservacoes",
               label: "Observações",
            }
        ];

        return (
            <div>
                <div className="form-wrapper">
                    <div className={this.appStore.width > 768 ? "content-panel" : ""}>
                        {this.checkExecucaoFluxos()}
                        <TabelaAdministracao
                            keyField={"timesheetId"}
                            nomeFluxo={'Timesheets não gerados'}
                            onChange={(value) => this.controller.setLista(value)}
                            listaItens={this.controller.timesheets}
                            colunas={colunas}
                            temBusca={true}
                            parametroVisualizar={"timesheetId"}
                            acoesItens={["examinarFalha"]}
                            acoesMultiplas={this.controller.acoesMultiplas}
                            loading={this.controller.loading}
                            controller={this.controller}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

